import { Controller } from "@hotwired/stimulus"

export default class ActivityReferenceBarController extends Controller {
  static targets = ["open", "closed", "tabs", "referenceInput"]
  static values = {
    open: Boolean,
    tabIndex: 0,
  }

  open() {
    this.openValue = true
  }

  close() {
    this.openValue = false
  }

  updateTabIndex(event) {
    this.tabIndexValue = event.detail.index
  }

  openValueChanged() {
    this.#toggle()
  }

  openTargetConnected() {
    this.#toggle()
  }

  closedTargetConnected() {
    this.#toggle()
  }

  removeReference({ params: { subjectKey } }) {
    const referenceInput = this.referenceInputTargets.find(
      (target) => target.dataset.subjectkey === subjectKey
    )

    referenceInput.disabled = false
  }

  tabsTargetConnected(element) {
    element.dataset.tabsIndexValue = this.tabIndexValue
  }

  #toggle() {
    if (this.openValue) {
      this.openTarget.classList.remove("hidden")
      this.closedTarget.classList.add("hidden")

      this.closedTarget
        .querySelectorAll("input")
        .forEach((elem) => (elem.disabled = true))
      this.openTarget
        .querySelectorAll("input")
        .forEach((elem) => elem.removeAttribute("disabled"))
    } else {
      this.closedTarget.classList.remove("hidden")
      this.openTarget.classList.add("hidden")

      this.openTarget
        .querySelectorAll("input")
        .forEach((elem) => (elem.disabled = true))
      this.closedTarget
        .querySelectorAll("input")
        .forEach((elem) => elem.removeAttribute("disabled"))
    }
  }
}
